import React from 'react';
import '../styles/Team.css';
import jonathanImg from './Pictures/jonathan.png';
import bryanImg from './Pictures/bryan.jpg';
import graceImg from './Pictures/grace.jpeg';
import maanviImg from './Pictures/maanvi.jpg';
import marinImg from './Pictures/marin_edited.JPG';
import aishaniImg from './Pictures/aishani.png';
import jaydenImg from './Pictures/jayden.jpeg';

function Team() {
  const teamMembers = [
    {
      id: 1,
      name: "Jonathan Zhang",
      role: "Co-President",
      bio: "Jonathan is a senior from Chicago studying CS and is a co-president of Blockchain Group. Passionate about blockchain tech, he’s here to foster a community of enthusiasts within Northwestern. He's contributed to open-source projects within the Ethereum ecosystem and developed smart contracts for Uniswap Labs.",
      image: jonathanImg
    },
    {
      id: 2,
      name: "Bryan Yuen",
      role: "Co-President",
      bio: "Bryan is a senior from Hong Kong studying Economics and Statistics, and currently serves as one of the co-presidents of Blockchain Group. He joined the club in Fall 2022 to connect with fellow students interested in cryptocurrencies and blockchain technologies. Since then, he has contributed to projects surrounding DAO governance and DeFi yield optimization. ",
      image: bryanImg
    },
    {
      id: 3,
      name: "Grace Yang",
      role: "Treasurer",
      bio: "Grace Yang is a junior from the Seattle area studying Computer Science and Entrepreneurship. She serves as the Treasurer of the Blockchain Group, helping manage the club’s budget and supporting event planning. Grace joined to explore how blockchain can solve real-world problems and to connect with others passionate about decentralized systems.",
      image: graceImg
    },
    {
      id: 4,
      name: "Maanvi Sarwadi",
      role: "VP of Communications",
      bio: "Maanvi is a junior from Delaware studying Computer Science with a minor in Legal Studies. She is also pursuing the Kellogg Certificate in Managerial Analytics. She currently serves as the Vice President of Communications. She joined the club in her Freshman year as a way to learn more about Blockchain and now is excited to introduce people to the concept of Web3 technology.",
      image: maanviImg
    },
    {
      id: 5,
      name: "Marin Holtrop",
      role: "VP of Marketing",
      bio: "Marin is a senior from Albuquerque studying Cognitive Science and pursuing the Medill Integrated Marketing Communications certificate. She serves as the Vice President of Marketing. She joined the club in Winter 2025 and is excited to provide information to students and connect with students who are interested in cryptocurrencies and blockchain technologies. ",
      image: marinImg
    },
    {
      id: 6,
      name: "Aishani Dhar",
      role: "VP of Operations",
      bio: "Aishani is a sophomore from Milwaukee studying Data Science with a minor in Business Institutions, and is the VP of Operations for the Blockchain Group. She joined the club last winter quarter and is excited to learn and connect with other students that are passionate about blockchain and crypto.",
      image: aishaniImg
    },
    {
      id: 7,
      name: "Jayden Huang",
      role: "VP of Technology",
      bio: "Jayden is a sophomore from Portland studying Computer Science and is the VP of Technology. He joined the club this year and is excited to explore the policy implications of blockchain technologies. ",
      image: jaydenImg
    }
  ];

  return (
    <div className="team-page">
      <div className="team-header">
        <h1>Our Leadership Team</h1>
        <p>Meet the dedicated students leading NU Blockchain Group's initiatives and growth.</p>
      </div>
      
      <div className="team-grid">
        {teamMembers.map(member => (
          <div key={member.id} className="team-member-card">
            <div className="member-image">
              <img src={member.image} alt={member.name} />
            </div>
            <div className="member-info">
              <h3>{member.name}</h3>
              <h4>{member.role}</h4>
              <p>{member.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Team;
